import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild, inject } from '@angular/core';

@Component({
  selector: 'orgbrain-sticky-bottom',
  templateUrl: './bottom-buttons.component.html',
  styleUrls: ['./bottom-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BottomButtonsComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('fixedEl') fixedEl: ElementRef;
  @Input() parentClass = '';
  @Input() fullWidthMode = false;
  @Input() borderBottomLeftRadius;
  @Input() borderBottomRightRadius;
  showContent = false;

  @HostListener('window:click', ['$event'])
  onClick(event: MouseEvent) {
    this.updateFixedChildWidth();
  }

  @HostListener('window:touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.updateFixedChildWidth();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.showContent = true;
      this.cdr.detectChanges();
    }, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateFixedChildWidth();
  }

  ngAfterViewInit(): void {
    this.updateFixedChildWidth();
  }

  ngAfterViewChecked() {
    this.updateFixedChildWidth();
  }

  updateFixedChildWidth(): void {
    if (!this.fullWidthMode) {
      let relativeToEl = this.fixedEl?.nativeElement?.parentElement?.parentElement;
      if (!this.parentClass) {
        this.fixedEl.nativeElement.style.width = relativeToEl.offsetWidth + 'px';
      } else {
        while (
          relativeToEl &&
          relativeToEl.parentElement &&
          relativeToEl.classList &&
          !relativeToEl.classList.contains(this.parentClass)
        ) {
          relativeToEl = relativeToEl.parentElement;
        }
        if (!relativeToEl) {
          return;
        }

        const rect =
          relativeToEl &&
          relativeToEl.getBoundingClientRect &&
          relativeToEl.getBoundingClientRect();
        if (rect) {
          this.fixedEl.nativeElement.style.width = relativeToEl.offsetWidth + 'px';
          this.fixedEl.nativeElement.style.left = rect.left + 'px';
        } else {
          this.fixedEl.nativeElement.style.width = relativeToEl.offsetWidth + 'px';
        }
      }
    } else {
      this.fixedEl.nativeElement.style.width = '100vw';
      this.fixedEl.nativeElement.style.left = 0;
    }

    if (this.borderBottomLeftRadius) {
      this.fixedEl.nativeElement.style['border-bottom-left-radius'] = this.borderBottomLeftRadius;
    }

    if (this.borderBottomRightRadius) {
      this.fixedEl.nativeElement.style['border-bottom-right-radius'] = this.borderBottomRightRadius;
    }
  }
}
